import React, { useState, useEffect } from 'react';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { func, number } from 'prop-types';
import { Loading, TableCustom, Modal } from '../../common';
import { ServerRequest } from '../../../utils/apiweb';
import { CloneObject } from '../../../utils/helpers';
import { APIS } from '../../../config/apis';

import './index.css';
import {TIPS} from "../../../consts/tips";

const TiposActoProcesalModal = (props) => {

  //hooks
  const [state, setState] = useState({
      showMessage: false,
      loading: false,
      showForm: false,
      rowForm: null,
      list: []
  });

  const mount = () => {

    SearchTiposActosProcesales();

  }
  useEffect(mount, []);

  //definiciones
  const cellS = (props) =>    <div className='action'>
                                <div onClick={ (event) => handleClickSelect(props.value) } className="link">
                                <span className="material-symbols-outlined" title="Seleccionar">west</span>
                                </div>
                              </div>

  const tableColumns = [
      { Header: '', Cell: cellS, id:'select', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true },
      { Header: 'Tipo acto procesal', Cell: (props) => {
          const row = props.row.original;

          let prefijo = "";
          const espacio = "\u00A0\u00A0\u00A0";
          const flecha =  (<span className="material-symbols-outlined">subdirectory_arrow_right</span>);

          if (row.nivel > 1){ prefijo = (
          <>
              <span>{espacio.repeat(row.nivel - 1)}</span>
              {flecha}
          </>)}

          const renglon =
          <div>
              <span>
                  {prefijo}{row.codigoActoProcesal} - {row.descripcion}
              </span>
          </div>

          return renglon;
        }, accessor: 'tipoActoProcesal', width: '95%' }, 
  ];


  //handles
  const handleClickSelect = (id) => {
    const row = state.list.find(f => f.id === id);
    props.onConfirm(id, CloneObject(row));
  }

  const handleClickSinSeleccion = () => {
    props.onConfirm(0, null);
  }

  //callbacks
  const callbackNoSuccess = (response) => {
    response.json()
    .then((error) => {
      const message = error.message;
      ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
      setState(prevState => {
        return {...prevState, loading: false};
      });
    })
    .catch((error) => {
        const message = 'Error procesando respuesta: ' + error;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
          return {...prevState, loading: false};
        });
    });
  }
  const callbackError = (error) => {
    const message = 'Error procesando solicitud: ' + error.message;
    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
    setState(prevState => {
      return {...prevState, loading: false};
    });
  }

  //funciones
  function SearchTiposActosProcesales() {
      setState(prevState => {
          return {...prevState, loading: true, list: []};
      });

      const callbackSuccess = (response) => {
          response.json()
          .then((data) => {
              setState(prevState => {
                  return {...prevState, loading: false, list: data};
              });
          })
          .catch((error) => {
              const message = 'Error procesando respuesta: ' + error;
              ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
              setState(prevState => {
                return {...prevState, loading: false, list: []};
              });
          });
      };


      ServerRequest(
          REQUEST_METHOD.GET,
          null,
          true,
          APIS.URLS.TIPO_ACTO_PROCESAL,
          null,
          null,
          callbackSuccess,
          callbackNoSuccess,
          callbackError
      );

  }

  return (
    <div className='medio-pago-modal'>

      <Loading visible={state.loading}></Loading>

      <Modal
        size="xl"
        title="Selección de tipo acto procesal"
        tipName={TIPS.NAME.MODALS.SELECCION_TIPO_ACTO_PROCESAL_MODAL}
        onEscape={() => props.onDismiss()}
        body={(
              <TableCustom
                  showFilterGlobal={true}
                  className={'TableCustomBase'}
                  columns={tableColumns}
                  data={state.list}
                  onClickRow={({ original }, colId) => props.onClickRow(original.id, original, colId)}
              />
        )}
        footer={(
              <div className='footer-action-container'>
                <button className="btn btn-outline-primary float-end" data-dismiss="modal" onClick={ (event) => handleClickSinSeleccion() }>Sin selección</button>
                <button className="btn back-button float-start" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
              </div>
        )}
      />

    </div>
  );
}

TiposActoProcesalModal.propTypes = {
  onConfirm: func.isRequired,
  onDismiss: func.isRequired
};

export default TiposActoProcesalModal;
